import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { ControlContainer, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { InputMask } from 'primeng/inputmask';

@Component({
    selector: 'app-dados-militares',
    standalone: true,
    imports: [ReactiveFormsModule, Select, InputMask],
    templateUrl: './dados-militares.html',
    styles: [
        `
            .erro-campo {
                color: var(--red-500, #ef4444);
                font-size: 0.72rem;
                font-weight: 500;
            }

            ::ng-deep .dados-militares-categoria-panel {
                min-width: 14rem;
                max-width: min(24rem, calc(100vw - 2rem));
            }

            ::ng-deep .dados-militares-categoria-panel .p-select-option {
                white-space: normal;
                overflow-wrap: anywhere;
                line-height: 1.25rem;
            }
        `
    ],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção de formulário de dados militares. */
export class DadosMilitaresComponent {
    private readonly controlContainer = inject(ControlContainer);

    modoEdicao = input<boolean>(false);
    opcoesCategoriaMilitar = input<{ label: string; value: string | number | boolean | null }[]>([]);

    campoInvalido(nomeCampo: string): boolean {
        const campo = this.form.get(nomeCampo);
        return !!campo && campo.invalid && (campo.touched || campo.dirty || this.modoEdicao());
    }

    mensagemErroCampo(nomeCampo: string): string {
        const campo = this.form.get(nomeCampo);

        if (campo?.hasError('dataInvalida')) {
            return 'Data inválida.';
        }

        if (campo?.hasError('dataMaiorQueHojeInvalida')) {
            return 'A data deve ser menor ou igual a hoje.';
        }

        return 'Valor inválido.';
    }

    classeDataMilitar(): string {
        const classeBase = !this.modoEdicao() ? 'w-full readonly-input' : 'w-full';
        return this.campoInvalido('decMilitarData') ? `${classeBase} p-invalid` : classeBase;
    }

    private get form(): FormGroup {
        return this.controlContainer.control as FormGroup;
    }
}
